<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-container class="ma-0 pa-0">
    <v-layout
      v-if="display_advanved_filters_applied.items.length > 0"
      class="ml-1 mr-1"
      row
    >
      <div class="result_box_no_border pa-0 mr-6">
        <v-tooltip left>
          <template v-slot:activator="{on, attrs}">
            <v-icon
              v-on="on"
              @click="$store.commit('toggleCountriesFilter', true)"
              class="mt-1"
              >mdi-earth
            </v-icon>
          </template>
          <span>Click to open market filters</span>
        </v-tooltip>
      </div>
      <v-flex class="mt-1">
        <v-expansion-panels
          v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate !== 'MP1C'
          "
          class="ma-0 pa-0 ml-0"
        >
          <v-expansion-panel class="elevation-0 mr-1">
            <v-expansion-panel-header class="ma-o pa-0">
              <template v-slot:default="{open}">
                <v-row v-if="open" class="justify-space-between align-center">
                  <v-flex class="ml-9" sm10>
                    <span class="ma-0 pa-0 ml-1"
                      >{{
                        $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                          .markets.C_Code.length > 0
                          ? 'Selected'
                          : 'Filtered'
                      }}
                      markets
                    </span>
                    <v-btn
                      x-small
                      text
                      @click.prevent="
                        html_to_xls_download('results_current_markets');
                        open = true;
                      "
                    >
                      <v-icon class="green--text">mdi-microsoft-excel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-row>
                <span v-else class="ml-2"
                  >Click to view
                  {{
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                      .markets.C_Code.length > 0
                      ? 'selected'
                      : 'filtered'
                  }}
                  markets ({{
                    $store.getters.selectionCounts.results.markets_count
                  }})</span
                >
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ma-0 pa-0">
              <v-data-table
                id="results_current_markets"
                :headers="display_advanved_filters_applied['headers']"
                :items="display_advanved_filters_applied['items']"
                :items-per-page="5"
                class="elevation-1 ma-0 pa-0"
                dense
                :footer-props="{
                  'items-per-page-options': calc_items_per_page(
                    display_advanved_filters_applied['items'].length,
                    4,
                    $store.state.user.userServerInfo.app_config.max_markets,
                  ),
                }"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div v-else class="sm11 green--text mt-0 text-left">
          {{ country_name() }}
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const {csvExport} = require('@/components/application-level/js_functions/jsFunctions');
const {
  html_to_xls_download,
} = require('@/components/application-level/js_functions/jsFunctions');

const {
  calc_items_per_page,
} = require('@/components/trade-dsm-application/mixins/calc_items_per_page');

export default {
  name: 'countries_filtered_box',
  methods: {
    csv: csvExport,
    calc_items_per_page: calc_items_per_page,
    html_to_xls_download: html_to_xls_download,
    country_name() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
          .C_Code.length > 0
      ) {
        return this.codeToMarket(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
            .C_Code[0],
        );
      } else {
        return '';
      }
    },
  },
  computed: {
    display_advanved_filters_applied() {
      // let return_list = {headers: [], items: []};
      // let item = []

      let items = this.countriesSearchAndSelectedList.filter(v => v.in_cube === true);

      let headers = [
        {
          text: 'Country',
          value: 'C_Name',
          class: 'table_header_color',
        },
        {
          text: 'Main Region',
          value: 'Main_Region',
          class: 'table_header_color',
        },
        {
          text: 'Sub Region',
          value: 'Sub_Region',
          class: 'table_header_color',
        },
        {
          text: 'Trade Group',
          value: 'Trade_Group',
          class: 'table_header_color',
        },
      ];

      return {
        headers: headers,
        items: items,
      };
    },
  },
};
</script>

<style scoped></style>
